import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import Layers from '@cover/weiterhelfen/weiterhelfen';
import bubbleTopSrc from '@cover/weiterhelfen/bubble-dots.svg';
import bubbleCenterSrc from '@cover/weiterhelfen/bubble-empty.svg';
import bubbleBottomSrc from '@cover/weiterhelfen/bubble-heart.svg';

const StyledLayers = styled(Layers)`
	position: absolute;
	height: 100%;
	top: 0%;
	left: 0%;
`
const AnimatedLayer = styled.img`
	position: absolute;
	transform-origin: center center;
	opacity: 0;
`
const BubbleTop = styled(AnimatedLayer)`
	height: 4.2%;
	top: 14.5%;
	left: 46.5%;
`
const BubbleCenter = styled(AnimatedLayer)`
	height: 6.3%;
	top: 48%;
	right: 7%;
`
const BubbleBottom = styled(AnimatedLayer)`
	height: 4.3%;
	bottom: 22.8%;
	right: 11%;
`

const WeiterHelfen = ({ play }) => {
	const layers = createRef();

		const bubbleTop = createRef();
		const bubbleCenter = createRef();
		const bubbleBottom = createRef();

	useEffect(() => {
		const personTopLeft = layers.current.querySelector('#weiterhelfen_svg__woman-top-left')
		const personTopRight = layers.current.querySelector('#weiterhelfen_svg__woman-top-right')
		const personBottom = layers.current.querySelector('#weiterhelfen_svg__girl-bottom')
		const dottedLine = layers.current.querySelector('#weiterhelfen_svg__dotted-line')

		// Dotted line
		const timelineDottedLine = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timelineDottedLine
		.add({
			targets: dottedLine.children,
			easing: 'easeInOutSine',
			delay: anime.stagger(50, {start: 500}),
			opacity: 1
		})
		.add({
			targets: dottedLine.children,
			easing: 'easeInOutSine',
			delay: anime.stagger(50, {start: 500}),
			opacity: 0,
			endDelay: 200
		})


		// Bubbles
		const timelineBubbles = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timelineBubbles
		.add({
			targets: bubbleTop.current,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, scale: 2.4, duration: 350},
				{translateY: '0%', translateX: '3%', rotate: 0.4, duration: 1100},
				{translateY: '3%', translateX: '3%', rotate: -0.5, duration: 1200},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 1200}
			]
		}, 1200)
		.add({
			targets: bubbleCenter.current,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, scale: 1.9, duration: 350},
				{translateY: '1%', translateX: '-1%', rotate: -0.3, duration: 1100},
				{translateY: '0%', translateX: '2%', rotate: 0.6, duration: 1100},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 1200}
			]
		}, 1600)
		.add({
			targets: bubbleBottom.current,
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 1, scale: 2, duration: 350},
				{translateY: '0%', translateX: '-2%', rotate: 0.3, duration: 1200},
				{translateY: '2%', translateX: '-2%', rotate: -0.4, duration: 1200},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 1100, endDelay: 1400}
			]
		}, 2000)
		.add({
			targets: [bubbleTop.current, bubbleCenter.current, bubbleBottom.current],
			easing: 'easeInOutSine',
			opacity: 0,
			scale: 1,
			duration: 450,
			endDelay: 1000,
		})


		// People
		const timelinePeople = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timelinePeople
		.add({
			targets: personTopLeft,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '0%', translateX: '0.2%', rotate: -0.4, duration: 1500},
				{translateY: '0.5%', translateX: '0.3%', rotate: 0.5, duration: 1700},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 1600}
			]
		})
		.add({
			targets: personTopRight,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-1%', translateX: '0.2%', rotate: 0.2, duration: 1700},
				{translateY: '-0.4%', translateX: '0.1%', rotate: -0.4, duration: 1500},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 1600}
			]
		}, 0)
		.add({
			targets: personBottom,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.1%', translateX: '-0.3', rotate: -0.3, duration: 1600},
				{translateY: '0.2%', translateX: '-0.3', rotate: 0.4, duration: 1500},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 1700}
			]
		}, 0)
	}, [play])
	return (
		<>
			<StyledLayers ref={layers}/>
			<BubbleTop src={bubbleTopSrc} ref={bubbleTop}/>
			<BubbleCenter src={bubbleCenterSrc} ref={bubbleCenter}/>
			<BubbleBottom src={bubbleBottomSrc} ref={bubbleBottom}/>
		</>
	)
};

export default WeiterHelfen;